import { render, staticRenderFns } from "./LibraryIndexEdit.vue?vue&type=template&id=65c8879b&"
import script from "./LibraryIndexEdit.vue?vue&type=script&lang=js&"
export * from "./LibraryIndexEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports